const u = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  hero: u("photo-1494412519320-aa613dfb7738", 1600),
  containers: u("photo-1606185540834-d6e7483ee1a4", 1800),
  port: u("photo-1670121180530-cfcba4438038", 1400),
};

// Placeholder contact details: replace with real ones when provided
export const CONTACT = {
  email: "kevinj@zenurametals.in",
  phone: "+91 9082911127",
  whatsapp: "+91 9082911127",
};

export const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "What we do" },
  { id: "materials", label: "Materials" },
  { id: "corridor", label: "Network" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

const SERVICE_IMGS = ["photo-1606185540834-d6e7483ee1a4", "photo-1714352069805-e0bf94d1381f", "photo-1516297702292-c919b6adea0c", "photo-1670121180530-cfcba4438038", "photo-1636624679304-232a9ca54736", "photo-1494412519320-aa613dfb7738"];

export const SERVICES = [
  { title: "Global Sourcing", text: "We identify and source quality ferrous and non-ferrous scrap from reliable, vetted international suppliers." },
  { title: "Indenting", text: "A trusted link between international suppliers and buyers — handling enquiries, negotiations and transactions." },
  { title: "International Trading", text: "Cross-border trading of metal scrap, built around reliable supply and long-term business relationships." },
  { title: "Import & Export", text: "Coordination of international shipments and the commercial processes that keep cargo moving." },
  { title: "Supplier & Buyer Network", text: "Strong relationships with recycling companies, scrap yards, traders, manufacturers and industrial buyers." },
  { title: "Market Access", text: "Connecting Indian buyers with international sources of quality metal scrap — and opening doors to other markets." },
].map((s, i) => ({ ...s, img: u(SERVICE_IMGS[i], 700) }));

export const MATERIALS = [
  { key: "aluminium", sym: "Al", name: "Aluminium Scrap", note: "Core focus", grades: "Extrusions · Wire · UBC · Cast · Turnings", img: u("photo-1516297702292-c919b6adea0c"), span: "lg:col-span-2 lg:row-span-2" },
  { key: "copper", sym: "Cu", name: "Copper Scrap", note: "Core focus", grades: "Millberry · Birch/Cliff · Berry/Candy · Wire", img: u("photo-1714352069805-e0bf94d1381f"), span: "lg:col-span-2 lg:row-span-2" },
  { key: "brass", sym: "CuZn", name: "Brass Scrap", grades: "Honey · Ocean · Turnings", img: u("photo-1636624679304-232a9ca54736", 900), span: "" },
  { key: "zinc", sym: "Zn", name: "Zinc Scrap", grades: "Die-cast · Old zinc · Dross", img: u("photo-1707783764111-502472d31ace", 900), span: "" },
  { key: "stainless", sym: "SS", name: "Stainless Steel Scrap", grades: "304 · 316 · Solids & turnings", img: u("photo-1763773203768-7b832ac7404b", 900), span: "" },
  { key: "nonferrous", sym: "NF", name: "Other Non-Ferrous", grades: "Mixed & specialty alloys", img: u("photo-1664569979825-c219969d3164", 900), span: "" },
  { key: "ferrous", sym: "Fe", name: "Ferrous Scrap", grades: "HMS 1&2 · Shredded · Busheling · Cast iron", img: u("photo-1769012334805-eb47a65b5d54", 1800), span: "lg:col-span-4" },
];

export const ORIGINS = ["Europe", "United Kingdom", "North America", "Middle East", "Africa", "Asia-Pacific"];
export const DESTS = ["India", "South-East Asia", "Other markets"];

export const STEPS = [
  { title: "Enquiry & specification", text: "We understand the material, grade, volume, destination and commercial expectations." },
  { title: "Sourcing & offers", text: "We approach trusted suppliers and yards, and present clear, comparable offers." },
  { title: "Negotiation & terms", text: "We negotiate competitive, transparent commercial terms that work for both sides." },
  { title: "Shipment coordination", text: "We coordinate documentation, loading and the commercial flow through to shipment." },
  { title: "Delivery & partnership", text: "Cargo arrives — and the relationship continues, deal after deal." },
];

export const VALUES = [
  { title: "Trust", text: "We work only with partners we would stake our name on." },
  { title: "Transparency", text: "Clear specifications, honest communication and no hidden terms." },
  { title: "Quality", text: "Material that matches the offer — grade, packing and paperwork." },
  { title: "Global Sourcing", text: "A widening network of international suppliers, yards and recyclers." },
  { title: "Long-Term Partnerships", text: "We measure success in years of repeat business, not single trades." },
];

export const MARQUEE = ["Aluminium", "Copper", "Brass", "Zinc", "Stainless Steel", "Non-Ferrous", "Ferrous"];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -108 });
  else el.scrollIntoView({ behavior: "smooth" });
};
